module.exports = __webpack_public_path__ + "img/thumbnail_BengalTiger_f_leucistic.b58b0a4a.png";